<template>
  <div>
    <p class="has-text-grey mb-1">{{ $t("mp:login.welcome.title") }}</p>

    <p class="is-size-3 has-text-weight-bold">
      {{ $t("mp:login.title") }}
    </p>

    <form @submit.prevent="doLogin">
      <validation-observer ref="observer">
        <BInputWithValidation
          :label="$t('mp:login.input.email.label')"
          rules="required|email"
          label-position="on-border"
          autocomplete="username"
          v-model="login.user"
        />

        <ValidationProvider
          rules="required"
          v-slot="{ errors, validated, valid }"
        >
          <b-field
            :label="$t('mp:login.input.password.label')"
            label-position="on-border"
            :type="{ 'is-danger': errors[0], 'is-success': validated && valid }"
            :message="errors"
            class="mb-5"
          >
            <b-input
              type="password"
              password-reveal
              autocomplete="current-password"
              v-model="login.password"
            ></b-input>
          </b-field>
        </ValidationProvider>
      </validation-observer>

      <b-button
        type="is-blue"
        native-type="submit"
        :loading="loading"
        expanded
        >{{ $t("mp:login.button.login") }}</b-button
      >
    </form>

    <div class="has-text-right mt-4">
      <router-link to="/reset-password">{{
        $t("mp:login.button.reset_password")
      }}</router-link>
    </div>

    <div class="mt-5">
      <span>{{ $t("mp:login.registration.title") }}</span>
      <router-link class="ml-2" to="/registration">{{
        $t("mp:login.registration.button")
      }}</router-link>
    </div>
  </div>
</template>

<script>
import { generateNonce } from "../utils/util";
import i18n from "../plugins/i18n";
import BInputWithValidation from "../components/input/BInputWithValidation";
import { LOGIN_STATUS } from "../utils/const";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "Login",
  title: "mp:page.login.title",
  components: {
    BInputWithValidation,
  },
  data() {
    return {
      loading: false,
      login: {
        nonce: generateNonce(),
        user: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      countries: "i18n/countries",
      country: "i18n/country",
    }),
    routerLocale() {
      return this.$route.params.locale;
    },
    locale() {
      return this.country?.languageIso;
    },
  },
  methods: {
    ...mapActions({
      fetchAllCountries: "i18n/fetchAllCountries",
    }),
    ...mapMutations({
      setCountryByLanguageIso: "i18n/setCountryByLanguageIso",
    }),
    async doLogin() {
      try {
        const valid = await this.$refs.observer.validate();
        if (!valid) return;

        this.loading = true;

        let request = this.login;
        let loginResponse = await this.$store.dispatch(
          "session/login",
          request
        );
        await this.$store.dispatch("session/saveSecondFactor", {
          id: loginResponse.secondFactorResponse.secondFactorId,
          nonce: request.nonce,
          status: loginResponse.status,
          user: request.user,
          maskedContact: loginResponse.secondFactorResponse.maskedContact,
        });

        if (LOGIN_STATUS.PASSWORD_CHANGE_REQUIRED === loginResponse.status) {
          await this.$router.push("/reset-password");
        } else {
          await this.$router.push("/second-factor");
        }
      } catch (ex) {
        console.warn(ex);
        this.$buefy.toast.open({
          message: i18n.t("mp:login.error.general"),
          type: "is-danger",
        });
      }
      this.loading = false;
    },
  },
  watch: {
    locale(newValue) {
      if (this.routerLocale && this.routerLocale !== this.locale) {
        this.$router.push({
          name: "LangLogin",
          params: {
            locale: newValue,
          },
        });
      }
    },
  },
  async created() {
    await this.fetchAllCountries();
    this.setCountryByLanguageIso(this.routerLocale);
    if (this.routerLocale && this.routerLocale !== this.locale) {
    }
  },
};
</script>

<style scoped lang="scss"></style>
